<div class="input-grid-gaps grid-6col container">
    <div class="fr-3 flex gap align-items-center">
        <p-fileupload #fuKval1 mode="basic" name="kval1[]" auto="false" [customUpload]="true"
            [chooseLabel]="'ePrescriptions.buttons.addCertPem' | translate"
            [disabled]="!userId()"
            chooseIcon="pi pi-upload" accept=".pem">
        </p-fileupload>
        @if (fuKval1.files.length) {
            <app-button icon="pi pi-times" (clickEvent)="fuKval1.clear()"></app-button>
        }
    </div>

    <div class="fr-3 flex gap align-items-center">
        <p-fileupload #fuKval2 mode="basic" name="kval2[]" auto="false" [customUpload]="true"
            [chooseLabel]="'ePrescriptions.buttons.addKeyPem' | translate"
            [disabled]="!userId()"
            chooseIcon="pi pi-upload" accept=".pem">
        </p-fileupload>
        @if (fuKval2.files.length) {
            <app-button icon="pi pi-times" (clickEvent)="fuKval2.clear()"></app-button>
        }
    </div>
</div>
